import { Component } from '@angular/core';
import { ModalContent } from './modal-content.component';

@Component({
    selector: 'span-link-modal',
    template: require('./span-link-modal.component.html')
})
export class SpanLinkModal extends ModalContent {

    public onOkayClicked(event: Event): void {
        if (this.modalOptions.onOkClickedCallBack) {
            this.modalOptions.onOkClickedCallBack(event);
        }

        this.modalDialogInfo.close();
    }

    public onCancelClicked(event: Event): void {
        if (this.modalOptions.onCancelClickedCallBack) {
            this.modalOptions.onCancelClickedCallBack(event);
        }

        this.modalDialogInfo.close();
    }

    public onDismissModal(event: Event): void {
        this.modalDialogInfo.dismiss();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/span-link-modal.component.ts